import React, { useEffect, useState } from 'react';
import ApexCharts from 'react-apexcharts';
import { addSpace } from '../Components/Tools';
import axios from 'axios';
import qs from 'qs';

function MatriculeTableauBord(props)
{
    const purple = '#6571FE';
    const green = '#59B44A';
    const [series, setSeries] = useState(undefined);
    const [options, setOptions] = useState(undefined);


    useEffect(() => {
        if (!series || !options)
        {
            /* Initialisation des options avec les années */
            var option_tmp = {
                legend: {
                  position: 'top',
                  offsetY: 10
                },
                chart: {
                  type: 'line',
                },
                title: {
                    text: props.intitule
                },
                yaxis: {
                    labels: {
                      formatter: function (value) {
                        return addSpace(Math.round(value*100)/100, true);
                      }
                    },
                },
                stroke: {
                  width: [0, 4]
                },
                xaxis: {
                    labels: {
                      rotate: -35
                    },
                    categories: ['janvier', 'fevrier', 'mars', 'avril', 'mai', 'juin', 'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'décembre'],
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    type: 'bar'
                },
            }

            setOptions(option_tmp);

            const monthNames = ['janvier', 'fevrier', 'mars', 'avril', 'mai', 'juin', 'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'decembre'];
            // Utiliser les valeurs mensuelles (pas de cumul)
            var mois = monthNames.map(m => {
                if (!props.grille[1][m]) return 0;
                return Math.round(props.grille[1][m]);
            });

            var budget_vote = monthNames.map((m, i) => Math.round((Math.round(props.grille[1].total_vote)) / 12 * (i + 1)));

            setSeries(
                props.intitule != 'Trésorerie moyenne sur le mois' && props.intitule != 'Solde de trésorerie fin de mois'?
                [{
                    name: "Montant",
                    data: mois,
                    color: props.color,
                    type: 'column',
                },
                {
                    name: "Budget voté",
                    data: budget_vote,
                    color: '#A3A3A3',
                    type: 'line'
                }]
                :
                [{
                    name: "Montant",
                    data: mois,
                    color: props.color,
                    type: 'column',
                }]
            )
        }
    }, [])



	return (
		<div className='shadow-xl' style={{margin: 5}}>
            {options && series?
			<ApexCharts
                series={series}
                options={options}
                width={props.width?props.width:400}
                height={props.height?props.height:270}
            />:null}
		</div>
	)
}

export default MatriculeTableauBord;
